import React from 'react';
import PropTypes from 'prop-types';

import { getTypedValue } from '../../lib/helpers';

const APYAnnotation = ({ data }) => {
  const content = getTypedValue(data, 'details.minimum_balance');
  return <div className="annotation">{content} minimum balance</div>;
};

APYAnnotation.propTypes = {
  data: PropTypes.shape({
    details: PropTypes.shape({
      minimum_balance: PropTypes.shape({
        value: PropTypes.number,
      }),
    }),
  }),
};

APYAnnotation.defaultProps = {
  data: {
    details: {
      minimum_balance: {
        value: 0,
        type: 'currency',
      },
    },
  },
};

APYAnnotation.displayName = 'APYAnnotation';

export default APYAnnotation;
